import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

const i18nInitPromise = i18n
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`~/locales/${language}/${namespace}.json`),
    ),
  )
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // prevent suspense as we preload below
    },
    ns: ["translation", "devices", "events", "zones"], // preload locales
    defaultNS: "translation",
  });

export { i18n, i18nInitPromise };
